var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81 2.361l-4.753 6.45a.698.698 0 01-.993.131L.669 6.228a.693.693 0 11.869-1.084l2.83 2.264L8.692 1.54a.696.696 0 111.118.821z",
    fill: "#00B49C",
    fillRule: "nonzero"
  })));
}
export default SvgSafetyCheck;